import React from 'react';
import { Link } from 'react-router-dom';
import { PageHeader, Button } from '../../../components/ui';
import { Reveal } from '../../../components/motion';
import styles from './NotFoundPage.module.css';

export default function NotFoundPage() {
  return (
    <div className={styles.wrap}>
      <Reveal as="p" variant="scaleIn" className={styles.code}>
        404
      </Reveal>
      <PageHeader
        title="Página no encontrada"
        subtitle="La ruta que buscas no existe o fue movida."
      />
      <Reveal delay={0.15} className={styles.actions}>
        <Link to="/welcome">
          <Button variant="secondary">Ir al inicio</Button>
        </Link>
        <Link to="/apuestas">
          <Button variant="cta">Jugar ahora</Button>
        </Link>
      </Reveal>
    </div>
  );
}
